import React from 'react';
import { Check, X, AlertTriangle } from 'lucide-react';

const IndustryCompetitorTable = ({ industry = 'plumber' }) => {
  
  const competitorData = {
    plumber: {
      competitors: [
        {
          name: "ServiceTitan",
          cost: "£297-497/month + £47/user",
          yearCost: "£6,528/year minimum",
          cons: [
            "Complex 6-8 week setup",
            "Requires dedicated staff member to manage",
            "Per-user fees add up fast (5 users = £235/mo extra)",
            "No AI call answering",
            "Limited automation",
            "Steep learning curve - weeks of training",
            "Expensive implementation fees (£2,000+)",
            "Annual contracts only",
            "Basic features cost extra"
          ]
        },
        {
          name: "Jobber",
          cost: "£129-349/month",
          yearCost: "£4,188/year",
          cons: [
            "No AI answering service",
            "Basic CRM only",
            "Manual follow-ups required",
            "Limited to 20 users on top plan",
            "No review automation",
            "Clunky mobile app",
            "No missed call text-back",
            "Pay more for integrations"
          ]
        },
        {
          name: "Housecall Pro",
          cost: "£129-349/month",
          yearCost: "£4,188/year",
          cons: [
            "No AI call handling",
            "Still missing calls when busy",
            "Basic scheduling only",
            "Limited marketing automation",
            "Per-user pricing gets expensive",
            "No automatic quote follow-ups",
            "Requires manual data entry",
            "Poor lead nurturing"
          ]
        }
      ],
      lbh: {
        cost: "£497/month",
        yearCost: "£5,964/year",
        pros: [
          "AI optionally answers EVERY call 24/7",
          "Automatic preset replies when you're busy",
          "Instant quote sending",
          "7-stage automatic follow-up",
          "Review automation (67% response rate)",
          "Up to 50 users included",
          "£50/month in credits (SMS, AI calls, emails)",
          "Setup done FOR you in 48 hours",
          "No per-user fees (up to 50)",
          "All core features included",
          "Cancel anytime - no contracts",
          "Built-in missed call text-back",
          "Smart calendar optimization"
        ]
      }
    },
    hvac: {
      competitors: [
        {
          name: "ServiceTitan",
          cost: "£397-697/month + £47/user",
          yearCost: "£8,364/year minimum",
          cons: [
            "Extremely expensive for small operations",
            "8-12 week implementation nightmare",
            "Requires full-time admin to manage",
            "Per-technician fees destroy margins",
            "No AI call answering",
            "Can't handle peak season call volume",
            "Annual contracts trap you in",
            "Extra fees for everything",
            "Overwhelmingly complex interface"
          ]
        },
        {
          name: "FieldEdge",
          cost: "£179-349/month + setup fees",
          yearCost: "£4,188/year",
          cons: [
            "No AI answering capability",
            "Still missing emergency calls",
            "Limited marketing automation",
            "Per-user costs add up",
            "No seasonal lead nurturing",
            "Clunky customer communication",
            "Manual follow-ups still required",
            "Poor mobile experience"
          ]
        }
      ],
      lbh: {
        cost: "£497/month",
        yearCost: "£5,964/year",
        pros: [
          "AI handles unlimited simultaneous calls",
          "Emergency call prioritization",
          "Peak season scaling built-in",
          "Maintenance contract automation",
          "Winter lead nurturing campaigns",
          "Up to 50 technicians/users included",
          "£50/month in credits (SMS, AI calls, emails)",
          "Done-for-you setup in 48 hours",
          "Smart scheduling & routing",
          "Automatic customer updates",
          "All core features included",
          "Cancel anytime",
          "Works 24/7 during heatwaves"
        ]
      }
    },
    roofing: {
      competitors: [
        {
          name: "JobNimbus",
          cost: "£75-150/user/month",
          yearCost: "£4,500-9,000/year (5 users)",
          cons: [
            "Per-user pricing kills profitability",
            "No AI call answering",
            "Manual storm lead tracking",
            "No automatic insurance documentation",
            "Can't scale during storm season",
            "Expensive with crew size",
            "Limited automation",
            "Clunky workflow",
            "No off-season lead nurturing"
          ]
        },
        {
          name: "AccuLynx",
          cost: "£297-597/month + per-user fees",
          yearCost: "£7,164/year minimum",
          cons: [
            "Expensive per-user licenses",
            "Complex setup (weeks)",
            "No AI answering service",
            "Manual estimate follow-ups",
            "Limited review automation",
            "Doesn't capture storm leads automatically",
            "Poor mobile experience",
            "High learning curve",
            "Annual contracts only"
          ]
        }
      ],
      lbh: {
        cost: "£497/month",
        yearCost: "£5,964/year",
        pros: [
          "Storm lead automation",
          "AI answers unlimited calls during storms",
          "Automatic insurance documentation",
          "Adjuster communication tracking",
          "Estimate follow-up automation (67% conversion)",
          "Up to 50 crew members included",
          "£50/month in credits (SMS, AI calls, emails)",
          "Off-season maintenance automation",
          "Photo/video collection system",
          "Review automation for credibility",
          "Setup done in 48 hours",
          "No per-user fees (up to 50)",
          "Works during weekend storms"
        ]
      }
    },
    dental: {
      competitors: [
        {
          name: "Dentrix",
          cost: "£497-797/month + per-chair fees",
          yearCost: "£9,564/year minimum",
          cons: [
            "Extremely expensive per-chair licensing",
            "On-premise server required (££)",
            "No AI call answering",
            "Basic appointment reminders only",
            "No patient reactivation automation",
            "Clunky patient communication",
            "Requires IT support",
            "No treatment plan follow-up",
            "Poor review management",
            "Doesn't capture after-hours calls"
          ]
        },
        {
          name: "Eaglesoft",
          cost: "£397-697/month + licenses",
          yearCost: "£8,364/year minimum",
          cons: [
            "Per-provider licensing fees",
            "No AI answering capability",
            "Still missing new patient calls",
            "Limited automation",
            "Basic text reminders only",
            "No reactivation campaigns",
            "Manual membership plan management",
            "Expensive add-ons required",
            "Difficult to use"
          ]
        },
        {
          name: "Open Dental",
          cost: "£129-249/month + support fees",
          yearCost: "£2,988/year + support",
          cons: [
            "No AI call answering",
            "Tech-heavy - needs IT person",
            "No patient reactivation",
            "Basic scheduling only",
            "Manual review requests",
            "No treatment plan automation",
            "Poor patient communication",
            "Limited mobile functionality",
            "Missing after-hours calls"
          ]
        }
      ],
      lbh: {
        cost: "£497/month",
        yearCost: "£5,964/year",
        pros: [
          "AI answers all calls 24/7",
          "Instant online booking",
          "87% no-show reduction with smart reminders",
          "Patient reactivation (41% book)",
          "Treatment plan follow-up automation",
          "Review automation (64% respond)",
          "Membership plan automation",
          "Up to 50 providers/chairs included",
          "£50/month in credits (SMS, AI calls, emails)",
          "Emergency appointment handling",
          "New patient campaigns",
          "Setup done in 48 hours",
          "No per-chair or per-provider fees (up to 50)"
        ]
      }
    }
  };

  const data = competitorData[industry] || competitorData.plumber;

  return (
    <div className="bg-gradient-to-br from-purple-900/30 to-indigo-900/30 rounded-2xl p-8 border-2 border-purple-500/30">
      
      <div className="text-center mb-8">
        <div className="inline-block bg-purple-600/20 border border-purple-500 rounded-full px-6 py-2 mb-4">
          <p className="text-purple-400 font-bold">
            ⚔️ INDUSTRY SOFTWARE COMPARISON
          </p>
        </div>
        <h3 className="text-3xl md:text-4xl font-black text-white mb-4">
          "Industry-Specific" Software vs. LBH
        </h3>
        <p className="text-xl text-gray-300 max-w-3xl mx-auto">
          You've probably heard of these. They're expensive, complicated, and STILL don't answer your calls.
        </p>
      </div>

      <div className="space-y-6">
        
        {/* Competitors */}
        {data.competitors.map((competitor, idx) => (
          <div key={idx} className="bg-gray-900/50 border-2 border-gray-700 rounded-xl p-6">
            <div className="flex items-start justify-between mb-4">
              <div>
                <h4 className="text-2xl font-bold text-white mb-1">{competitor.name}</h4>
                <p className="text-2xl font-black text-orange-400">{competitor.cost}</p>
                <p className="text-sm text-gray-400 mt-1">{competitor.yearCost}</p>
              </div>
              <div className="bg-orange-600 text-white px-3 py-1 rounded-full text-xs font-bold">
                EXPENSIVE
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-2">
              {competitor.cons.map((con, i) => (
                <div key={i} className="flex items-start">
                  <X className="text-red-400 mr-2 mt-1 flex-shrink-0" size={16} />
                  <span className="text-gray-300 text-sm">{con}</span>
                </div>
              ))}
            </div>
          </div>
        ))}

        {/* LBH Winner */}
        <div className="bg-gradient-to-br from-green-600/30 to-emerald-600/30 border-4 border-green-500 rounded-xl p-6 relative">
          <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-green-600 to-emerald-600 text-white px-6 py-2 rounded-full font-black text-sm animate-pulse shadow-lg">
            ✨ HALF THE PRICE. 10X THE VALUE ✨
          </div>

          <div className="flex items-start justify-between mb-4 mt-4">
            <div>
              <h4 className="text-2xl font-bold text-white mb-1">Local Business Heroes</h4>
              <p className="text-3xl font-black text-green-400">{data.lbh.cost}</p>
              <p className="text-sm text-green-300 mt-1">{data.lbh.yearCost} - Save £2,200-£3,600/year</p>
            </div>
            <div className="bg-green-600 text-white px-3 py-1 rounded-full text-xs font-bold">
              BEST VALUE
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-2">
            {data.lbh.pros.map((pro, i) => (
              <div key={i} className="flex items-start">
                <Check className="text-green-400 mr-2 mt-1 flex-shrink-0" size={16} />
                <span className="text-white text-sm font-medium">{pro}</span>
              </div>
            ))}
          </div>

          <div className="mt-6 p-4 bg-gradient-to-r from-green-600/40 to-emerald-600/40 rounded-lg border border-green-500/50">
            <p className="text-white text-lg font-bold text-center">
              Same features. None of the headaches. Half the price. Plus AI that actually answers calls.
            </p>
          </div>
        </div>

      </div>

      {/* Bottom Summary */}
      <div className="mt-8 bg-indigo-900/40 rounded-xl p-6 border border-indigo-500/30">
        <div className="text-center">
          <p className="text-2xl font-bold text-white mb-4">
            Why Pay More For Less?
          </p>
          <div className="grid md:grid-cols-3 gap-4 text-center">
            <div>
              <p className="text-gray-400 text-sm mb-1">Other Software</p>
              <p className="text-3xl font-black text-orange-400">£4,188-9,564</p>
              <p className="text-xs text-gray-400">per year</p>
            </div>
            <div className="flex items-center justify-center">
              <AlertTriangle className="text-yellow-400" size={32} />
            </div>
            <div>
              <p className="text-gray-400 text-sm mb-1">LBH System</p>
              <p className="text-3xl font-black text-green-400">£5,964</p>
              <p className="text-xs text-green-300">per year + 50 users + £50/mo credits</p>
            </div>
          </div>
          <p className="text-gray-300 mt-4">
            <strong className="text-white">They charge per-user fees.</strong> We include 50 users.<br />
            <strong className="text-white">They nickel and dime you.</strong> We include £50/month in credits (covers most businesses).<br />
            <strong className="text-white">They make setup complicated.</strong> We do it for you in 48 hours.<br />
            <strong className="text-white">They still can't answer calls.</strong> Our AI handles everything.
          </p>
        </div>
      </div>

    </div>
  );
};

export default IndustryCompetitorTable;
